export const PREGUNTAS = 83
export const RESPUESTAS = 84
export const TIPOS = 93
export const ESTADOS = 94